import {
  INPUT_CONCENTRATION_COLUMN_TYPES,
  COLUMN_TYPE,
  TRANSFER_PRIMARY_INPUT_COLUMN_TYPES,
  TRANSFER_PRIMARY_OUTPUT_COLUMN_TYPES,
  TRANSFER_QUANTITY_COLUMN_TYPES,
  SpreadsheetColumn,
} from './SpreadsheetBulkImportConstants';
import * as SpreadsheetBulkImportUtil from './SpreadsheetBulkImportUtil';

export function getInputColumnsError(columns: Array<SpreadsheetColumn>, isRequired: boolean): string | null {
  const inputColumns = columns.filter(({type}) => TRANSFER_PRIMARY_INPUT_COLUMN_TYPES.includes(type));
  if (inputColumns.length > 1 || (isRequired && inputColumns.length === 0)) {
    return 'There must be exactly one source entity or container (by barcode or by well location in plate) column specified.';
  }
  const dependentColumnTypesError = SpreadsheetBulkImportUtil.getDependentColumnTypesError(columns, [
    [COLUMN_TYPE.INPUT_GRID_BARCODE, COLUMN_TYPE.INPUT_GRID_COORDINATES],
  ]);
  if (dependentColumnTypesError) {
    return dependentColumnTypesError;
  }
  return null;
}

export function getOutputColumnsError(columns: Array<SpreadsheetColumn>, isRequired: boolean): string | null {
  const outputColumns = columns.filter(({type}) => TRANSFER_PRIMARY_OUTPUT_COLUMN_TYPES.includes(type));
  if (outputColumns.length > 1 || (isRequired && outputColumns.length === 0)) {
    return (
      'There must be exactly one destination container ' +
      '(by barcode or by well location in plate) column specified.'
    );
  }
  const dependentColumnTypesError = SpreadsheetBulkImportUtil.getDependentColumnTypesError(columns, [
    [COLUMN_TYPE.OUTPUT_GRID_BARCODE, COLUMN_TYPE.OUTPUT_GRID_COORDINATES],
  ]);
  if (dependentColumnTypesError) {
    return dependentColumnTypesError;
  }
  return null;
}

export function getMeasurementColumnsError(
  columns: Array<SpreadsheetColumn>,
  isInputColumnRequired: boolean
): string | null {
  const dependentColumnTypesError = SpreadsheetBulkImportUtil.getDependentColumnTypesError(columns, [
    INPUT_CONCENTRATION_COLUMN_TYPES,
    TRANSFER_QUANTITY_COLUMN_TYPES,
  ]);
  if (dependentColumnTypesError) {
    return dependentColumnTypesError;
  }
  const hasInputContainableColumn = columns.some(({type}) =>
    [COLUMN_TYPE.INPUT_BIOENTITY_LABEL, COLUMN_TYPE.INPUT_BATCH_NAME].includes(type)
  );
  const hasInputConcentrationColumns = columns.some(({type}) =>
    INPUT_CONCENTRATION_COLUMN_TYPES.includes(type)
  );
  if (isInputColumnRequired && !hasInputContainableColumn && hasInputConcentrationColumns) {
    return 'Input concentration can only be specified if input supports concentrations.';
  }
  return null;
}
